
export class UpdateDanceEventCoHostsRequestDto {
  coHosts: string[];
}
